import { ref, watch, onBeforeUnmount } from 'vue';
import { loadStripe } from '@stripe/stripe-js/pure';

// src/useCheckout.ts

// src/langue.ts
var LOCALES_STRIPE = [
  "ar",
  "bg",
  "cs",
  "da",
  "de",
  "el",
  "en",
  "en-AU",
  "en-CA",
  "en-NZ",
  "en-GB",
  "es",
  "es-ES",
  "es-419",
  "et",
  "fi",
  "fil",
  "fr",
  "fr-CA",
  "fr-FR",
  "he",
  "hu",
  "hr",
  "id",
  "it",
  "it-IT",
  "ja",
  "ko",
  "lt",
  "lv",
  "ms",
  "mt",
  "nb",
  "nl",
  "no",
  "pl",
  "pt",
  "pt-BR",
  "ro",
  "ru",
  "sk",
  "sl",
  "sv",
  "th",
  "tr",
  "vi",
  "zh",
  "zh-HK",
  "zh-TW"
];
function localeStripe(locale) {
  if (!locale) return "fr-FR";
  const normalisee = locale.replace("_", "-").toLowerCase();
  const exacte = LOCALES_STRIPE.find((l) => l.toLowerCase() === normalisee);
  if (exacte) return exacte;
  const langue = normalisee.split("-")[0];
  return LOCALES_STRIPE.find((l) => l === langue) ?? "auto";
}
var TEXTES = {
  carteIncomplete: {
    fr: "Les informations de votre carte sont incompl\xE8tes.",
    en: "Your card details are incomplete.",
    de: "Ihre Kartendaten sind unvollst\xE4ndig.",
    es: "Los datos de su tarjeta est\xE1n incompletos.",
    it: "I dati della vostra carta sono incompleti.",
    nl: "Uw kaartgegevens zijn onvolledig."
  },
  paiementRefuse: {
    fr: "Paiement refus\xE9.",
    en: "Payment declined.",
    de: "Zahlung abgelehnt.",
    es: "Pago rechazado.",
    it: "Pagamento rifiutato.",
    nl: "Betaling geweigerd."
  },
  googlePayEchec: {
    fr: "Le paiement Google Pay n'a pas abouti et vous n'avez pas \xE9t\xE9 d\xE9bit\xE9. R\xE9essayez ou choisissez un autre moyen de paiement.",
    en: "The Google Pay payment did not go through and you have not been charged. Try again or choose another payment method.",
    de: "Die Zahlung mit Google Pay ist nicht durchgegangen, es wurde nichts abgebucht. Versuchen Sie es erneut oder w\xE4hlen Sie eine andere Zahlungsart.",
    es: "El pago con Google Pay no se ha completado y no se le ha cargado nada. Vuelva a intentarlo o elija otro m\xE9todo de pago.",
    it: "Il pagamento con Google Pay non \xE8 andato a buon fine e non vi \xE8 stato addebitato nulla. Riprovate o scegliete un altro metodo di pagamento.",
    nl: "De betaling met Google Pay is niet gelukt en er is niets afgeschreven. Probeer het opnieuw of kies een andere betaalmethode."
  },
  carteRefusee: {
    fr: "Votre carte a \xE9t\xE9 refus\xE9e. V\xE9rifiez votre solde, vos plafonds, ou essayez une autre carte.",
    en: "Your card was declined. Check your balance and limits, or try another card.",
    de: "Ihre Karte wurde abgelehnt. Pr\xFCfen Sie Ihr Guthaben und Ihre Limits oder versuchen Sie es mit einer anderen Karte.",
    es: "Su tarjeta ha sido rechazada. Compruebe su saldo y sus l\xEDmites, o pruebe con otra tarjeta.",
    it: "La vostra carta \xE8 stata rifiutata. Verificate il saldo e i massimali, oppure provate un'altra carta.",
    nl: "Uw kaart is geweigerd. Controleer uw saldo en limieten, of probeer een andere kaart."
  },
  carteExpiree: {
    fr: "Votre carte est expir\xE9e. Utilisez une autre carte ou mettez \xE0 jour sa date d'expiration.",
    en: "Your card has expired. Use another card or update its expiry date.",
    de: "Ihre Karte ist abgelaufen. Verwenden Sie eine andere Karte oder korrigieren Sie das Ablaufdatum.",
    es: "Su tarjeta est\xE1 caducada. Use otra tarjeta o corrija la fecha de caducidad.",
    it: "La vostra carta \xE8 scaduta. Usate un'altra carta o correggete la data di scadenza.",
    nl: "Uw kaart is verlopen. Gebruik een andere kaart of pas de vervaldatum aan."
  },
  typeCarteRefuse: {
    fr: "Ce type de carte n'est pas accept\xE9. Utilisez une Visa, Mastercard ou American Express.",
    en: "This type of card is not accepted. Use a Visa, Mastercard or American Express.",
    de: "Dieser Kartentyp wird nicht akzeptiert. Verwenden Sie eine Visa, Mastercard oder American Express.",
    es: "Este tipo de tarjeta no se acepta. Use una Visa, Mastercard o American Express.",
    it: "Questo tipo di carta non \xE8 accettato. Usate una Visa, Mastercard o American Express.",
    nl: "Dit type kaart wordt niet geaccepteerd. Gebruik een Visa, Mastercard of American Express."
  },
  fondsInsuffisants: {
    fr: "Fonds insuffisants sur la carte. Essayez une autre carte ou un autre moyen de paiement.",
    en: "Insufficient funds on the card. Try another card or another payment method.",
    de: "Nicht gen\xFCgend Guthaben auf der Karte. Versuchen Sie es mit einer anderen Karte oder Zahlungsart.",
    es: "Fondos insuficientes en la tarjeta. Pruebe con otra tarjeta u otro m\xE9todo de pago.",
    it: "Fondi insufficienti sulla carta. Provate un'altra carta o un altro metodo di pagamento.",
    nl: "Onvoldoende saldo op de kaart. Probeer een andere kaart of een andere betaalmethode."
  },
  authentificationEchouee: {
    fr: "L'authentification 3D Secure a \xE9chou\xE9. R\xE9essayez ou contactez votre banque.",
    en: "3D Secure authentication failed. Try again or contact your bank.",
    de: "Die 3D-Secure-Authentifizierung ist fehlgeschlagen. Versuchen Sie es erneut oder wenden Sie sich an Ihre Bank.",
    es: "La autenticaci\xF3n 3D Secure ha fallado. Vuelva a intentarlo o contacte con su banco.",
    it: "L'autenticazione 3D Secure non \xE8 riuscita. Riprovate o contattate la vostra banca.",
    nl: "De 3D Secure-verificatie is mislukt. Probeer het opnieuw of neem contact op met uw bank."
  },
  numeroInvalide: {
    fr: "Num\xE9ro de carte invalide. V\xE9rifiez et r\xE9essayez.",
    en: "Invalid card number. Check it and try again.",
    de: "Ung\xFCltige Kartennummer. Pr\xFCfen Sie sie und versuchen Sie es erneut.",
    es: "N\xFAmero de tarjeta no v\xE1lido. Compru\xE9belo y vuelva a intentarlo.",
    it: "Numero di carta non valido. Verificate e riprovate.",
    nl: "Ongeldig kaartnummer. Controleer het en probeer het opnieuw."
  },
  expirationInvalide: {
    fr: "Date d'expiration invalide. Format attendu MM/AA.",
    en: "Invalid expiry date. Expected format MM/YY.",
    de: "Ung\xFCltiges Ablaufdatum. Erwartetes Format MM/JJ.",
    es: "Fecha de caducidad no v\xE1lida. Formato esperado MM/AA.",
    it: "Data di scadenza non valida. Formato atteso MM/AA.",
    nl: "Ongeldige vervaldatum. Verwacht formaat MM/JJ."
  },
  cvcInvalide: {
    fr: "Code de s\xE9curit\xE9 (CVC) invalide. V\xE9rifiez les 3 chiffres au dos de la carte.",
    en: "Invalid security code (CVC). Check the 3 digits on the back of the card.",
    de: "Ung\xFCltiger Sicherheitscode (CVC). Pr\xFCfen Sie die 3 Ziffern auf der R\xFCckseite der Karte.",
    es: "C\xF3digo de seguridad (CVC) no v\xE1lido. Compruebe los 3 d\xEDgitos del reverso de la tarjeta.",
    it: "Codice di sicurezza (CVC) non valido. Verificate le 3 cifre sul retro della carta.",
    nl: "Ongeldige beveiligingscode (CVC). Controleer de 3 cijfers op de achterkant van de kaart."
  },
  carteInvalide: {
    fr: "Les informations de la carte sont invalides. V\xE9rifiez chaque champ et r\xE9essayez.",
    en: "The card details are invalid. Check each field and try again.",
    de: "Die Kartendaten sind ung\xFCltig. Pr\xFCfen Sie jedes Feld und versuchen Sie es erneut.",
    es: "Los datos de la tarjeta no son v\xE1lidos. Revise cada campo y vuelva a intentarlo.",
    it: "I dati della carta non sono validi. Verificate ogni campo e riprovate.",
    nl: "De kaartgegevens zijn ongeldig. Controleer elk veld en probeer het opnieuw."
  },
  doublon: {
    fr: "Cette transaction semble \xEAtre un doublon. V\xE9rifiez votre historique avant de r\xE9essayer.",
    en: "This transaction looks like a duplicate. Check your history before trying again.",
    de: "Diese Transaktion scheint doppelt zu sein. Pr\xFCfen Sie Ihren Verlauf, bevor Sie es erneut versuchen.",
    es: "Esta transacci\xF3n parece duplicada. Revise su historial antes de volver a intentarlo.",
    it: "Questa transazione sembra un doppione. Verificate lo storico prima di riprovare.",
    nl: "Deze transactie lijkt dubbel. Controleer uw overzicht voordat u het opnieuw probeert."
  },
  tropDeTentatives: {
    fr: "Trop de tentatives en peu de temps. Patientez quelques minutes avant de r\xE9essayer.",
    en: "Too many attempts in a short time. Wait a few minutes before trying again.",
    de: "Zu viele Versuche in kurzer Zeit. Warten Sie einige Minuten, bevor Sie es erneut versuchen.",
    es: "Demasiados intentos en poco tiempo. Espere unos minutos antes de volver a intentarlo.",
    it: "Troppi tentativi in poco tempo. Attendete qualche minuto prima di riprovare.",
    nl: "Te veel pogingen in korte tijd. Wacht enkele minuten voordat u het opnieuw probeert."
  },
  connexion: {
    fr: "Probl\xE8me de connexion. V\xE9rifiez votre internet et r\xE9essayez.",
    en: "Connection problem. Check your internet connection and try again.",
    de: "Verbindungsproblem. Pr\xFCfen Sie Ihre Internetverbindung und versuchen Sie es erneut.",
    es: "Problema de conexi\xF3n. Compruebe su conexi\xF3n a internet y vuelva a intentarlo.",
    it: "Problema di connessione. Verificate la connessione internet e riprovate.",
    nl: "Verbindingsprobleem. Controleer uw internetverbinding en probeer het opnieuw."
  },
  carteRefuseeCourt: {
    fr: "Votre carte a \xE9t\xE9 refus\xE9e. V\xE9rifiez votre solde ou essayez une autre carte.",
    en: "Your card was declined. Check your balance or try another card.",
    de: "Ihre Karte wurde abgelehnt. Pr\xFCfen Sie Ihr Guthaben oder versuchen Sie es mit einer anderen Karte.",
    es: "Su tarjeta ha sido rechazada. Compruebe su saldo o pruebe con otra tarjeta.",
    it: "La vostra carta \xE8 stata rifiutata. Verificate il saldo o provate un'altra carta.",
    nl: "Uw kaart is geweigerd. Controleer uw saldo of probeer een andere kaart."
  },
  echecCarte: {
    fr: "Le paiement n'a pas pu \xEAtre effectu\xE9. V\xE9rifiez vos informations de carte et r\xE9essayez.",
    en: "The payment could not be completed. Check your card details and try again.",
    de: "Die Zahlung konnte nicht ausgef\xFChrt werden. Pr\xFCfen Sie Ihre Kartendaten und versuchen Sie es erneut.",
    es: "No se ha podido realizar el pago. Revise los datos de su tarjeta y vuelva a intentarlo.",
    it: "Non \xE8 stato possibile effettuare il pagamento. Verificate i dati della carta e riprovate.",
    nl: "De betaling kon niet worden uitgevoerd. Controleer uw kaartgegevens en probeer het opnieuw."
  }
};
function textePaiement(locale, cle) {
  const langue = (locale ?? "fr").split(/[-_]/)[0]?.toLowerCase();
  return TEXTES[cle][langue] ?? TEXTES[cle].fr;
}

// src/chargementScripts.ts
var DELAIS_REESSAI_SCRIPTS_MS = [800, 2e3, 4e3];
var attendreParDefaut = (ms) => new Promise((r) => setTimeout(r, ms));
async function avecReessais(charger, reessayable, delais = DELAIS_REESSAI_SCRIPTS_MS, attendre = attendreParDefaut) {
  for (let tentative = 0; ; tentative++) {
    try {
      return await charger();
    } catch (err) {
      const delai = delais[tentative];
      if (delai === void 0 || !reessayable(err)) throw err;
      await attendre(delai);
    }
  }
}
var EchecChargementScript = class extends Error {
  constructor(src) {
    super(`\xC9chec du chargement du script ${src}`);
    this.name = "EchecChargementScript";
  }
};
var chargementsEnCours = /* @__PURE__ */ new Map();
function chargerScript(id, src, configurer) {
  const enCours = chargementsEnCours.get(id);
  if (enCours) return enCours;
  const promesse = new Promise((resolve, reject) => {
    const existant = document.getElementById(id);
    if (existant?.dataset.charge === "ok") return resolve();
    existant?.remove();
    const script = document.createElement("script");
    script.id = id;
    script.src = src;
    script.async = true;
    script.onload = () => {
      script.dataset.charge = "ok";
      resolve();
    };
    script.onerror = () => {
      script.remove();
      reject(new EchecChargementScript(src));
    };
    document.head.appendChild(script);
  }).finally(() => chargementsEnCours.delete(id));
  chargementsEnCours.set(id, promesse);
  return promesse;
}

// src/providers/StripeProvider.ts
function echecChargementStripe(err) {
  const message = err instanceof Error ? err.message : "";
  return /Failed to load Stripe\.js|Stripe\.js not available/i.test(message);
}
var StripeProvider = class {
  name = "stripe";
  stripe = null;
  elements = null;
  cardElements = null;
  // séparé : Card Element n'est pas en deferred mode
  expressCheckoutElement = null;
  paymentElement = null;
  cardElement = null;
  cardElementComplete = false;
  cardElementError = null;
  onCardChangeCallback = null;
  currentContext = null;
  currentHandlers = null;
  availability = {
    applePay: false,
    googlePay: false,
    link: false,
    paypal: false
  };
  connectedAccountId;
  /** Langue de la page (« de-DE ») : champs Stripe et messages au donateur. */
  locale;
  async init(config) {
    if (this.stripe) return;
    this.connectedAccountId = config.connectedAccountId;
    void this.connectedAccountId;
    this.locale = config.locale;
    this.stripe = await avecReessais(
      () => loadStripe(config.publicKey, {
        stripeAccount: config.connectedAccountId,
        // Langue de la page : « Numéro de carte » devient « Kartennummer ».
        locale: localeStripe(config.locale)
      }),
      echecChargementStripe
    );
    if (!this.stripe) {
      throw new Error("Stripe.js a \xE9chou\xE9 \xE0 charger (v\xE9rifiez la cl\xE9 publique)");
    }
  }
  async detectAvailability() {
    return this.availability;
  }
  async mountExpressCheckout(containerId, handlers, initialContext) {
    if (!this.stripe) throw new Error("StripeProvider.init() doit \xEAtre appel\xE9 d'abord");
    this.currentHandlers = handlers;
    this.currentContext = initialContext;
    this.elements = this.stripe.elements({
      mode: initialContext.recurring ? "subscription" : "payment",
      amount: Math.round(initialContext.amount * 100),
      currency: initialContext.currency,
      paymentMethodCreation: "manual"
    });
    this.expressCheckoutElement = this.elements.create("expressCheckout", {
      buttonType: { applePay: "plain", googlePay: "plain" },
      buttonTheme: { applePay: "black", googlePay: "black" },
      buttonHeight: 44,
      layout: { maxColumns: 2, overflow: "never" },
      // Récupère l'email du wallet sans page intermédiaire (Apple Pay/Google Pay)
      emailRequired: true,
      paymentMethods: {
        applePay: "always",
        googlePay: "always",
        // Link (Karim 02/11/2026) : paiement en un clic avec la carte que le
        // donateur a enregistrée chez Stripe. Même tarif qu'une carte, autorisé
        // sur les comptes des associations (vérifié en test et en prod). Le
        // paiement reste confirmé comme Apple Pay et Google Pay ci-dessous.
        link: "auto",
        // Klarna interdit les associations et les collectes de fonds.
        klarna: "never"
      }
    });
    this.expressCheckoutElement.on("ready", (event) => {
      const methods = event.availablePaymentMethods ?? {};
      this.availability = {
        applePay: methods.applePay === true,
        googlePay: methods.googlePay === true,
        link: methods.link === true,
        paypal: false
      };
    });
    this.expressCheckoutElement.on("click", async (event) => {
      if (handlers.onClick) {
        const allowed = await handlers.onClick();
        if (!allowed) {
          return;
        }
      }
      event.resolve();
    });
    this.expressCheckoutElement.on("confirm", async (event) => {
      if (!this.currentContext || !this.currentHandlers || !this.elements || !this.stripe) {
        return;
      }
      try {
        const evenement = event;
        let walletEmail = evenement.billingDetails?.email;
        const submitResult = await this.elements.submit();
        if (submitResult.error) {
          throw new Error(submitResult.error.message ?? "Submit error");
        }
        let moyenLink;
        if (evenement.expressPaymentType === "link") {
          const { paymentMethod, error: erreurMoyen } = await this.stripe.createPaymentMethod({
            elements: this.elements
          });
          if (erreurMoyen || !paymentMethod) {
            throw new Error(erreurMoyen?.message ?? "Link : moyen de paiement non cr\xE9\xE9");
          }
          moyenLink = paymentMethod.id;
          walletEmail = walletEmail ?? paymentMethod.billing_details?.email ?? paymentMethod.link?.email ?? void 0;
        }
        const ctxWithWalletEmail = {
          ...this.currentContext,
          donor: {
            ...this.currentContext.donor,
            email: this.currentContext.donor.email || walletEmail
          }
        };
        const intent = await this.currentHandlers.onConfirm(ctxWithWalletEmail);
        const returnUrl = this.buildReturnUrl(
          this.currentHandlers.successUrl(ctxWithWalletEmail.donor.email),
          ctxWithWalletEmail.donor.email
        );
        const { error } = moyenLink ? await this.stripe.confirmPayment({
          clientSecret: intent.clientSecret,
          confirmParams: { payment_method: moyenLink, return_url: returnUrl }
        }) : await this.stripe.confirmPayment({
          elements: this.elements,
          clientSecret: intent.clientSecret,
          confirmParams: {
            return_url: returnUrl,
            payment_method_data: {
              billing_details: {
                email: ctxWithWalletEmail.donor.email,
                name: ctxWithWalletEmail.donor.name
              }
            }
          }
        });
        if (error) {
          console.error("[StripeProvider] confirmPayment error:", error);
        }
      } catch (err) {
        console.error("[StripeProvider] onConfirm error:", err);
      }
    });
    await this.waitForElement(containerId);
    this.expressCheckoutElement.mount(`#${containerId}`);
  }
  async updateExpressCheckout(context) {
    this.currentContext = context;
    if (!this.elements) return;
    this.elements.update({
      amount: Math.round(context.amount * 100),
      currency: context.currency,
      mode: context.recurring ? "subscription" : "payment"
    });
  }
  async mountCardForm(containerId, options, _onCapture) {
    if (!this.stripe) throw new Error("Stripe non initialis\xE9");
    const formType = options?.type ?? "payment";
    if (formType === "card-legacy") {
      try {
        this.cardElement?.unmount();
      } catch {
      }
      this.cardElement = null;
      this.cardElementComplete = false;
      this.cardElementError = null;
      this.cardElements = this.stripe.elements();
      this.cardElement = this.cardElements.create("card", {
        style: {
          base: {
            fontSize: "16px",
            color: "#32325d",
            fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
            "::placeholder": { color: "#aab7c4" }
          },
          invalid: { color: "#fa755a", iconColor: "#fa755a" }
        },
        hidePostalCode: true
      });
      this.onCardChangeCallback = options?.onCardChange ?? null;
      this.cardElement.on("change", (e) => {
        this.cardElementComplete = e.complete;
        this.cardElementError = e.error?.message ?? null;
        this.onCardChangeCallback?.();
      });
      this.cardElement.on("focus", () => {
        this.onCardChangeCallback?.();
      });
      await this.waitForElement(containerId);
      this.cardElement.mount(`#${containerId}`);
      return;
    }
    if (!this.elements) {
      throw new Error(
        "Express Checkout doit \xEAtre mont\xE9 avant le Payment Element (partage le m\xEAme elements)"
      );
    }
    this.paymentElement = this.elements.create("payment", {
      layout: "tabs",
      defaultValues: {
        billingDetails: {
          email: this.currentContext?.donor.email,
          name: this.currentContext?.donor.name
        }
      }
    });
    await this.waitForElement(containerId);
    this.paymentElement.mount(`#${containerId}`);
  }
  async confirmCardPayment(context, createPaymentIntent, successUrl) {
    if (!this.stripe) {
      return {
        error: { message: "Stripe non initialis\xE9", type: "validation_error" }
      };
    }
    try {
      if (this.cardElement) {
        if (!this.cardElementComplete) {
          return {
            error: {
              message: this.cardElementError ?? textePaiement(this.locale, "carteIncomplete"),
              type: "card_error"
            }
          };
        }
        const intent2 = await createPaymentIntent(context);
        const { error: error2, paymentIntent } = await this.stripe.confirmCardPayment(
          intent2.clientSecret,
          {
            payment_method: {
              card: this.cardElement,
              billing_details: {
                email: context.donor.email,
                name: context.donor.name,
                phone: context.donor.phone
              }
            }
          },
          { handleActions: true }
        );
        if (error2) {
          return {
            error: {
              message: error2.message ?? "\xC9chec du paiement",
              type: error2.type === "card_error" ? "card_error" : "unknown",
              code: error2.code
            }
          };
        }
        if (paymentIntent && (paymentIntent.status === "succeeded" || paymentIntent.status === "processing")) {
          if (typeof window !== "undefined") {
            window.location.href = this.buildReturnUrl(
              successUrl(context.donor.email),
              context.donor.email,
              paymentIntent.id
            );
          }
        }
        return {};
      }
      if (!this.elements) {
        return {
          error: {
            message: "Aucun formulaire carte mont\xE9",
            type: "validation_error"
          }
        };
      }
      const submitResult = await this.elements.submit();
      if (submitResult.error) {
        return {
          error: {
            message: submitResult.error.message ?? "Erreur de validation",
            type: "validation_error"
          }
        };
      }
      const intent = await createPaymentIntent(context);
      const returnUrl = this.buildReturnUrl(
        successUrl(context.donor.email),
        context.donor.email
      );
      const { error } = await this.stripe.confirmPayment({
        elements: this.elements,
        clientSecret: intent.clientSecret,
        confirmParams: {
          return_url: returnUrl,
          payment_method_data: {
            billing_details: {
              email: context.donor.email,
              name: context.donor.name,
              phone: context.donor.phone,
              address: context.donor.address
            }
          }
        }
      });
      if (error) {
        return {
          error: {
            message: error.message ?? "\xC9chec du paiement",
            type: error.type === "card_error" ? "card_error" : "unknown",
            code: error.code
          }
        };
      }
      return {};
    } catch (err) {
      const message = err instanceof Error ? err.message : "Erreur inconnue";
      return { error: { message, type: "unknown" } };
    }
  }
  /**
   * Paie par Bancontact (chantier « autres pays », étape B) : paiement créé
   * avec ce moyen (`context.moyenPaiement`, que la page transmet au serveur),
   * puis redirection vers la banque. Stripe ramène le donateur sur
   * `successUrl` en y ajoutant `payment_intent`, `payment_intent_client_secret`
   * et `redirect_status` (« succeeded » ou « failed »). Bancontact exige le
   * nom du titulaire : la page ne propose le bouton qu'une fois le nom saisi.
   */
  async confirmerMoyenLocal(moyen, context, createPaymentIntent, successUrl) {
    if (!this.stripe) {
      return { error: { message: "Stripe non initialis\xE9", type: "validation_error" } };
    }
    try {
      const intent = await createPaymentIntent({ ...context, moyenPaiement: moyen });
      const billing_details = { name: context.donor.name ?? "", email: context.donor.email };
      const return_url = this.retourAvecPageDOrigine(this.buildReturnUrl(successUrl(context.donor.email), context.donor.email), moyen);
      const { error } = moyen === "ideal" ? await this.stripe.confirmIdealPayment(intent.clientSecret, { payment_method: { ideal: {}, billing_details }, return_url }) : moyen === "revolut_pay" ? await this.stripe.confirmPayment({
        clientSecret: intent.clientSecret,
        confirmParams: {
          payment_method_data: { type: "revolut_pay", billing_details },
          return_url
        }
      }) : moyen === "wero" ? await this.stripe.confirmWeroPayment(intent.clientSecret, {
        payment_method: { wero: {}, billing_details },
        return_url
      }) : await this.stripe.confirmBancontactPayment(intent.clientSecret, { payment_method: { billing_details }, return_url });
      if (error) {
        return {
          error: {
            message: error.message ?? "\xC9chec du paiement",
            type: "local_method_error",
            code: error.code,
            param: error.param
          }
        };
      }
      return {};
    } catch (err) {
      const message = err instanceof Error ? err.message : "Erreur inconnue";
      return { error: { message, type: "local_method_error" } };
    }
  }
  /**
   * Ajoute la page de don d'origine (`retour`) à l'URL de retour d'une
   * redirection : si la banque refuse, la page de remerciement propose de
   * réessayer sur CETTE page (le référent serait la page de la banque). Et
   * le moyen (`moyen`) : la page dit lequel n'a pas abouti (01/11/2026).
   */
  retourAvecPageDOrigine(url, moyen) {
    if (typeof window === "undefined") return url;
    try {
      const u = new URL(url);
      u.searchParams.set("retour", `${window.location.pathname}${window.location.search}`);
      if (moyen) u.searchParams.set("moyen", moyen);
      return u.toString();
    } catch {
      return url;
    }
  }
  /**
   * Confirme un paiement RÉCURRENT (subscription Stripe).
   * Flow en 4 étapes : SetupIntent → confirmCardSetup → Subscription → confirmCardPayment.
   * Nécessite un Card Element legacy déjà monté (Subscription incompatible avec Payment Element deferred).
   */
  async confirmSubscription(context, handlers, successUrl) {
    if (!this.stripe || !this.cardElement) {
      return {
        error: {
          message: "Card Element non mont\xE9 (subscription requiert card-legacy)",
          type: "validation_error"
        }
      };
    }
    try {
      const setupIntent = await handlers.createSetupIntent(context);
      const setupResult = await this.stripe.confirmCardSetup(
        setupIntent.setupSecret,
        {
          payment_method: {
            card: this.cardElement,
            billing_details: {
              email: context.donor.email,
              name: context.donor.name,
              phone: context.donor.phone
            }
          }
        }
      );
      if (setupResult.error) {
        return {
          error: {
            message: setupResult.error.message ?? "\xC9chec de la configuration",
            type: setupResult.error.type === "card_error" ? "card_error" : "unknown",
            code: setupResult.error.code
          }
        };
      }
      const subResult = await handlers.createSubscription(
        context,
        setupIntent.setupIntentId
      );
      if (subResult.clientSecret && subResult.clientSecret.length > 0) {
        const { error: confirmError, paymentIntent } = await this.stripe.confirmCardPayment(
          subResult.clientSecret,
          {
            payment_method: {
              card: this.cardElement,
              billing_details: {
                email: context.donor.email,
                name: context.donor.name,
                phone: context.donor.phone
              }
            }
          },
          { handleActions: true }
        );
        if (confirmError) {
          const alreadySucceeded = confirmError.code === "payment_intent_unexpected_state" || confirmError.message?.includes("already succeeded");
          if (!alreadySucceeded) {
            return {
              error: {
                message: confirmError.message ?? "\xC9chec du paiement de l'abonnement",
                type: confirmError.type === "card_error" ? "card_error" : "unknown",
                code: confirmError.code
              },
              subscriptionId: subResult.subscriptionId
            };
          }
        }
        if (paymentIntent && (paymentIntent.status === "succeeded" || paymentIntent.status === "processing")) {
          if (typeof window !== "undefined") {
            window.location.href = this.buildReturnUrl(
              successUrl(context.donor.email),
              context.donor.email,
              subResult.subscriptionId,
              "subscription_id"
            );
          }
          return { subscriptionId: subResult.subscriptionId };
        }
      }
      if (typeof window !== "undefined") {
        window.location.href = this.buildReturnUrl(
          successUrl(context.donor.email),
          context.donor.email,
          subResult.subscriptionId,
          "subscription_id"
        );
      }
      return { subscriptionId: subResult.subscriptionId };
    } catch (err) {
      const message = err instanceof Error ? err.message : "Erreur inconnue";
      return { error: { message, type: "unknown" } };
    }
  }
  // ─── Prélèvement SEPA (Karim, 02/11/2026) ──────────────────────────────────
  //
  // Formulaire de STRIPE (Payment Element limité au prélèvement) : champ IBAN
  // et texte du mandat SEPA obligatoire, dans la langue de la page — jamais
  // réécrits à la main. Le nom et l'e-mail viennent du formulaire de la page.
  // Le don est confirmé quelques jours plus tard : la page de remerciement le
  // dit (`moyen=sepa_debit`).
  elementsSepa = null;
  elementSepa = null;
  sepaMensuel = false;
  /** Monte le formulaire SEPA dans `#conteneur`. `false` si Stripe n'est pas prêt. */
  monterPrelevementSepa(conteneur, options) {
    if (!this.stripe || typeof document === "undefined" || !document.getElementById(conteneur)) return false;
    this.demonterPrelevementSepa();
    this.sepaMensuel = options.mensuel;
    const commun = {
      currency: "eur",
      paymentMethodTypes: ["sepa_debit"],
      locale: localeStripe(this.locale),
      appearance: { theme: "stripe" }
    };
    this.elementsSepa = options.mensuel ? this.stripe.elements({ mode: "setup", ...commun }) : this.stripe.elements({ mode: "payment", amount: Math.max(50, Math.round(options.montantCentimes)), ...commun });
    this.elementSepa = this.elementsSepa.create("payment", {
      fields: { billingDetails: { name: "never", email: "never" } }
    });
    this.elementSepa.mount(`#${conteneur}`);
    return true;
  }
  /** Montant changé sur la page : le formulaire suit (don ponctuel). */
  mettreAJourPrelevementSepa(montantCentimes) {
    if (this.elementsSepa && !this.sepaMensuel && montantCentimes >= 50) {
      this.elementsSepa.update({ amount: Math.round(montantCentimes) });
    }
  }
  demonterPrelevementSepa() {
    try {
      this.elementSepa?.destroy();
    } catch {
    }
    this.elementSepa = null;
    this.elementsSepa = null;
  }
  /** Don PONCTUEL par prélèvement : paiement créé, mandat accepté, page de remerciement. */
  async confirmerPrelevementSepa(context, createPaymentIntent, successUrl) {
    if (!this.stripe || !this.elementsSepa) {
      return { error: { message: "Formulaire de pr\xE9l\xE8vement non pr\xEAt", type: "validation_error" } };
    }
    try {
      const { error: erreurSaisie } = await this.elementsSepa.submit();
      if (erreurSaisie) {
        return { error: { message: erreurSaisie.message ?? "IBAN incomplet", type: "validation_error", code: erreurSaisie.code } };
      }
      const intent = await createPaymentIntent({ ...context, moyenPaiement: "sepa_debit" });
      const retour = this.retourAvecPageDOrigine(
        this.buildReturnUrl(successUrl(context.donor.email), context.donor.email),
        "sepa_debit"
      );
      const { error, paymentIntent } = await this.stripe.confirmPayment({
        elements: this.elementsSepa,
        clientSecret: intent.clientSecret,
        confirmParams: {
          return_url: retour,
          payment_method_data: { billing_details: { name: context.donor.name ?? "", email: context.donor.email } }
        },
        redirect: "if_required"
      });
      if (error) {
        return { error: { message: error.message ?? "\xC9chec du pr\xE9l\xE8vement", type: "local_method_error", code: error.code } };
      }
      if (paymentIntent && typeof window !== "undefined") {
        window.location.href = this.buildReturnUrl(retour, context.donor.email, paymentIntent.id);
      }
      return {};
    } catch (err) {
      const message = err instanceof Error ? err.message : "Erreur inconnue";
      return { error: { message, type: "local_method_error" } };
    }
  }
  /**
   * Don MENSUEL par prélèvement : mandat accepté (SetupIntent), puis
   * abonnement — Stripe prélève lui-même chaque mois avec ce mandat.
   */
  async confirmerAbonnementPrelevementSepa(context, handlers, successUrl) {
    if (!this.stripe || !this.elementsSepa) {
      return { error: { message: "Formulaire de pr\xE9l\xE8vement non pr\xEAt", type: "validation_error" } };
    }
    try {
      const { error: erreurSaisie } = await this.elementsSepa.submit();
      if (erreurSaisie) {
        return { error: { message: erreurSaisie.message ?? "IBAN incomplet", type: "validation_error", code: erreurSaisie.code } };
      }
      const ctx = { ...context, moyenPaiement: "sepa_debit" };
      const setup = await handlers.createSetupIntent(ctx);
      const retour = this.retourAvecPageDOrigine(
        this.buildReturnUrl(successUrl(context.donor.email), context.donor.email),
        "sepa_debit"
      );
      const { error } = await this.stripe.confirmSetup({
        elements: this.elementsSepa,
        clientSecret: setup.setupSecret,
        confirmParams: {
          return_url: retour,
          payment_method_data: { billing_details: { name: context.donor.name ?? "", email: context.donor.email } }
        },
        redirect: "if_required"
      });
      if (error) {
        return { error: { message: error.message ?? "\xC9chec du mandat de pr\xE9l\xE8vement", type: "local_method_error", code: error.code } };
      }
      const abonnement = await handlers.createSubscription(ctx, setup.setupIntentId);
      if (typeof window !== "undefined") {
        window.location.href = this.buildReturnUrl(retour, context.donor.email, abonnement.subscriptionId, "subscription_id");
      }
      return { subscriptionId: abonnement.subscriptionId };
    } catch (err) {
      const message = err instanceof Error ? err.message : "Erreur inconnue";
      return { error: { message, type: "local_method_error" } };
    }
  }
  destroyExpressCheckout() {
    try {
      this.expressCheckoutElement?.unmount();
    } catch {
    }
    this.expressCheckoutElement = null;
  }
  destroy() {
    try {
      this.expressCheckoutElement?.unmount();
      this.paymentElement?.unmount();
      this.cardElement?.unmount();
    } catch {
    }
    this.expressCheckoutElement = null;
    this.paymentElement = null;
    this.cardElement = null;
    this.cardElementComplete = false;
    this.cardElementError = null;
    this.elements = null;
    this.cardElements = null;
    this.currentContext = null;
    this.currentHandlers = null;
  }
  // === Helpers privés ===
  buildReturnUrl(baseUrl, donorEmail, extraIdValue, extraIdKey = "payment_intent_id") {
    const origin = typeof window !== "undefined" ? window.location.origin : "https://donoor.org";
    try {
      const url = new URL(baseUrl, origin);
      if (donorEmail && !url.searchParams.get("email")) {
        url.searchParams.set("email", donorEmail);
      }
      if (extraIdValue && !url.searchParams.get(extraIdKey)) {
        url.searchParams.set(extraIdKey, extraIdValue);
      }
      return url.toString();
    } catch {
      const absoluteBase = baseUrl.startsWith("http") ? baseUrl : `${origin}${baseUrl.startsWith("/") ? "" : "/"}${baseUrl}`;
      const parts = [];
      if (donorEmail) parts.push(`email=${encodeURIComponent(donorEmail)}`);
      if (extraIdValue)
        parts.push(`${extraIdKey}=${encodeURIComponent(extraIdValue)}`);
      const sep = absoluteBase.includes("?") ? "&" : "?";
      return parts.length ? `${absoluteBase}${sep}${parts.join("&")}` : absoluteBase;
    }
  }
  async waitForElement(id, timeoutMs = 5e3) {
    const start = Date.now();
    return new Promise((resolve, reject) => {
      const tick = () => {
        const el = document.getElementById(id);
        if (el) return resolve(el);
        if (Date.now() - start > timeoutMs) {
          return reject(new Error(`Element #${id} not found in DOM after ${timeoutMs}ms`));
        }
        requestAnimationFrame(tick);
      };
      tick();
    });
  }
};

// src/diagnostics.ts
var CLE_RAPPORTEUR = Symbol.for("donoor.checkout.rapporteurErreurPaiement");
var registre = globalThis;
function definirRapporteurErreurPaiement(fn) {
  registre[CLE_RAPPORTEUR] = fn;
}
function extraireDebugIdPaypal(erreur) {
  if (!erreur) return void 0;
  if (typeof erreur === "object") {
    const e = erreur;
    for (const cle of ["paypalDebugId", "debug_id", "debugId", "correlationId"]) {
      const v = e[cle];
      if (typeof v === "string" && v.trim()) return v.trim();
    }
  }
  const texte = erreur instanceof Error ? erreur.message : typeof erreur === "string" ? erreur : "";
  const trouve = texte.match(/"debug_id"\s*:\s*"([A-Za-z0-9-]+)"/) ?? texte.match(/Corr(?:elation)?[ _-]?ID[:\s]+([A-Za-z0-9-]+)/i) ?? texte.match(/"correlation_id"\s*:\s*"([A-Za-z0-9-]+)"/);
  return trouve?.[1];
}
function signalerErreurPaiement(e) {
  const rapporteur = registre[CLE_RAPPORTEUR];
  if (!rapporteur) return;
  try {
    rapporteur({ ...e, paypalDebugId: extraireDebugIdPaypal(e.erreur) });
  } catch {
  }
}

// src/providers/PaypalProvider.ts
var sdkLoadPromise = null;
var currentSdkParams = null;
function echecChargementSdkPaypal(err) {
  const message = err instanceof Error ? err.message : "";
  return /Failed to load PayPal SDK script|PayPal SDK loaded but window\.paypal is undefined/.test(message);
}
async function loadPayPalSdk(opts) {
  if (typeof window === "undefined") {
    throw new Error("PaypalProvider can only be used in a browser context");
  }
  const params = new URLSearchParams({
    "client-id": opts.clientId,
    currency: opts.currency.toUpperCase(),
    components: opts.components.join(","),
    intent: opts.intent ?? "capture",
    // `commit=true` → "Pay Now" experience (le bouton sur la page de review
    // PayPal devient "Pay Now" au lieu de "Continue" → 1 step de moins pour
    // le buyer). REQUIS par l'IWT pour les transactions où le montant est
    // déjà finalisé (cas Donoor : montant choisi par le donateur).
    commit: "true",
    ...opts.vault ? { vault: "true" } : {},
    ...opts.locale ? { locale: opts.locale } : {},
    ...opts.buyerCountry ? { "buyer-country": opts.buyerCountry } : {},
    ...opts.merchantId ? { "merchant-id": opts.merchantId } : {}
  });
  const paramsString = params.toString();
  if (sdkLoadPromise && currentSdkParams === paramsString && window.paypal) {
    return window.paypal;
  }
  if (currentSdkParams && currentSdkParams !== paramsString) {
    const oldScripts = document.querySelectorAll(
      'script[data-donoor-paypal-sdk="true"]'
    );
    oldScripts.forEach((s) => s.remove());
    delete window.paypal;
    sdkLoadPromise = null;
  }
  if (!sdkLoadPromise) {
    currentSdkParams = paramsString;
    const promesse = new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.src = `https://www.paypal.com/sdk/js?${paramsString}`;
      script.setAttribute("data-donoor-paypal-sdk", "true");
      if (opts.partnerAttributionId) {
        script.setAttribute(
          "data-partner-attribution-id",
          opts.partnerAttributionId
        );
      }
      if (opts.pageType) {
        script.setAttribute("data-page-type", opts.pageType);
      }
      script.async = true;
      script.onload = () => {
        if (window.paypal) {
          resolve(window.paypal);
        } else {
          script.remove();
          reject(new Error("PayPal SDK loaded but window.paypal is undefined"));
        }
      };
      script.onerror = () => {
        script.remove();
        reject(new Error("Failed to load PayPal SDK script"));
      };
      document.head.appendChild(script);
    });
    sdkLoadPromise = promesse;
    promesse.catch(() => {
      if (sdkLoadPromise === promesse) {
        sdkLoadPromise = null;
        currentSdkParams = null;
      }
    });
  }
  return sdkLoadPromise;
}
function mapPaypalCardErrorMessage(raw, locale) {
  const texte = (cle) => textePaiement(locale, cle);
  const lower = raw.toLowerCase();
  let issue = null;
  let field = null;
  try {
    const jsonMatch = raw.match(/\{[\s\S]+\}/);
    if (jsonMatch) {
      const parsed = JSON.parse(jsonMatch[0]);
      issue = parsed.details?.[0]?.issue ?? parsed.name ?? null;
      field = parsed.details?.[0]?.field ?? null;
    }
  } catch {
  }
  if (issue) {
    const i = issue.toUpperCase();
    if (i.includes("INSTRUMENT_DECLINED") || i.includes("PAYMENT_DENIED")) {
      return texte("carteRefusee");
    }
    if (i.includes("CARD_EXPIRED") || i.includes("EXPIRED_CARD")) {
      return texte("carteExpiree");
    }
    if (i.includes("CARD_TYPE_NOT_SUPPORTED")) {
      return texte("typeCarteRefuse");
    }
    if (i.includes("INSUFFICIENT_FUNDS")) {
      return texte("fondsInsuffisants");
    }
    if (i.includes("AUTHENTICATION") || i.includes("PAYER_ACTION_REQUIRED")) {
      return texte("authentificationEchouee");
    }
    if (i.includes("VALIDATION_ERROR") || i.includes("INVALID")) {
      if (field?.includes("card/number")) {
        return texte("numeroInvalide");
      }
      if (field?.includes("card/expiry")) {
        return texte("expirationInvalide");
      }
      if (field?.includes("card/security_code") || field?.includes("cvv")) {
        return texte("cvcInvalide");
      }
      return texte("carteInvalide");
    }
    if (i.includes("DUPLICATE")) {
      return texte("doublon");
    }
    if (i.includes("RATE_LIMIT")) {
      return texte("tropDeTentatives");
    }
  }
  if (lower.includes("network") || lower.includes("timeout")) {
    return texte("connexion");
  }
  if (lower.includes("declined") || lower.includes("refused")) {
    return texte("carteRefuseeCourt");
  }
  return texte("echecCarte");
}
var PaypalProvider = class {
  name = "paypal";
  sdk = null;
  merchantId;
  clientId;
  currency = "EUR";
  locale = "fr_FR";
  availability = {
    applePay: false,
    googlePay: false,
    link: false,
    paypal: false
  };
  currentContext = null;
  currentHandlers = null;
  /**
   * Raison du dernier refus de capture côté serveur (carte refusée par la
   * banque…), déjà rédigée pour le donateur par l'API. Le SDK CardFields peut
   * emballer ou avaler l'erreur levée dans `onApprove` : on la garde ici pour
   * que `confirmCardPayment` affiche CETTE raison (« Fonds insuffisants… »)
   * et jamais une redirection « merci » sans paiement.
   */
  derniereErreurCapture = null;
  /**
   * Erreurs déjà signalées : le SDK renvoie souvent la même erreur à plusieurs
   * endroits (`onApprove` → `onError` → `submit()`), une seule remontée suffit.
   */
  erreursSignalees = /* @__PURE__ */ new WeakSet();
  buttonsInstance = null;
  cardFieldsInstance = null;
  /**
   * State de validité des CardFields, mis à jour en temps réel via
   * `inputEvents.onChange` du SDK. Exposé au composant Vue via
   * `getCardFieldsValidity()` pour griser le bouton "Payer" quand invalide.
   */
  cardFieldsValidity = {
    isFormValid: false,
    number: { isValid: false, isPotentiallyValid: true },
    expiry: { isValid: false, isPotentiallyValid: true },
    cvv: { isValid: false, isPotentiallyValid: true }
  };
  cardFieldsValidityListeners = /* @__PURE__ */ new Set();
  async init(config) {
    if (this.sdk) return;
    this.clientId = config.publicKey;
    this.merchantId = config.connectedAccountId;
    this.currency = (config.currency ?? "eur").toUpperCase();
    this.locale = (config.locale ?? "fr-FR").replace("-", "_");
    const options = {
      clientId: this.clientId,
      merchantId: this.merchantId,
      currency: this.currency,
      components: ["buttons", "card-fields", "applepay", "googlepay"],
      intent: "capture",
      vault: true,
      locale: this.locale,
      // `buyer-country` UNIQUEMENT en sandbox : en production PayPal rejette
      // l'URL du SDK avec un 400 (« buyer-country disallowed in production
      // env »), ce qui cassait TOUT le bouton PayPal (SDK jamais chargé). En
      // prod le pays de l'acheteur est détecté automatiquement.
      ...config.sandbox ? { buyerCountry: "FR" } : {},
      // BN code + page type pour l'IWT et l'analytics PayPal. Falls back
      // sur "checkout" par défaut puisque PaypalProvider est uniquement
      // utilisé dans les pages de paiement Donoor.
      partnerAttributionId: config.partnerAttributionId,
      pageType: config.pageType ?? "checkout"
    };
    this.sdk = await avecReessais(() => loadPayPalSdk(options), echecChargementSdkPaypal).catch((err) => {
      signalerErreurPaiement({
        provider: "paypal",
        etape: "sdk.chargement",
        erreur: err,
        gravite: "erreur"
      });
      throw err;
    });
  }
  async detectAvailability() {
    if (!this.sdk) return this.availability;
    this.availability.paypal = true;
    if (this.sdk.Applepay) {
      try {
        const ap = this.sdk.Applepay();
        const cfg = await ap.config();
        const applePaySessionOk = typeof window !== "undefined" && window.ApplePaySession?.canMakePayments?.() === true;
        this.availability.applePay = cfg.isEligible === true && applePaySessionOk;
      } catch {
        this.availability.applePay = false;
      }
    }
    if (this.sdk.Googlepay) {
      try {
        const gp = this.sdk.Googlepay();
        const cfg = await gp.config();
        this.availability.googlePay = Array.isArray(cfg.allowedPaymentMethods) && cfg.allowedPaymentMethods.length > 0;
      } catch {
        this.availability.googlePay = false;
      }
    }
    this.availability.link = false;
    return this.availability;
  }
  async mountExpressCheckout(containerId, handlers, initialContext) {
    if (!this.sdk) {
      throw new Error("PaypalProvider.init() doit \xEAtre appel\xE9 d'abord");
    }
    this.currentHandlers = handlers;
    this.currentContext = initialContext;
    try {
      this.buttonsInstance?.close();
    } catch {
    }
    this.buttonsInstance = null;
    if (typeof document !== "undefined") {
      const el = document.getElementById(containerId);
      if (el) el.innerHTML = "";
    }
    const isRecurring = !!initialContext.recurring;
    const buttonsConfig = {
      style: {
        // `horizontal` : mode officiel PayPal pour un bouton FULL-WIDTH.
        // On n'affiche qu'UN seul bouton (PayPal seul ; Stripe gère le
        // reste), donc pas besoin du vertical (fait pour empiler plusieurs
        // moyens de paiement). En horizontal, le SDK étire son bouton à
        // 100% du container (jusqu'au max 750px imposé par PayPal), ce qui
        // permet de l'aligner sur la largeur des autres blocs du formulaire.
        // Remplace l'ancien `vertical` + hack container 300px centré.
        // Karim 2026-07-05.
        layout: "horizontal",
        color: "gold",
        shape: "rect",
        label: isRecurring ? "subscribe" : "paypal",
        height: 44,
        tagline: false
      },
      // ⚠️ PAS d'App Switch (`appSwitchWhenAvailable`) : au retour de l'app
      // PayPal, la page devait relancer l'encaissement elle-même — impossible
      // dans un nouvel onglet, une iframe ou l'app Donoor. Le donateur validait
      // sans être débité. Retiré le 2026-10-06, cf. PaypalExperienceContext
      // (API) et memory/paypal_app_switch_retire_2026-10-06.md.
      onClick: handlers.onClick ? async () => {
        const allowed = await handlers.onClick();
        return allowed;
      } : void 0,
      onError: (err) => {
        console.error("[PaypalProvider] onError:", err);
        console.error(
          "[PaypalProvider] handlers.onError available?",
          typeof handlers.onError
        );
        this.signaler("bouton.sdk", err, "erreur");
        handlers.onError?.(err);
      },
      onCancel: () => {
        console.info("[PaypalProvider] Donor cancelled checkout");
      }
    };
    if (isRecurring) {
      buttonsConfig.createSubscription = async () => {
        if (!this.currentContext) throw new Error("No context");
        const intent = await this.currentHandlers.onConfirm(
          this.currentContext
        );
        return intent.clientSecret;
      };
      buttonsConfig.onApprove = async (data) => {
        if (typeof window !== "undefined" && handlers.successUrl) {
          const email = this.currentContext?.donor.email;
          const url = this.buildReturnUrl(
            handlers.successUrl(email),
            email,
            data.subscriptionID,
            "paypal_subscription_id"
          );
          window.location.href = url;
        }
      };
    } else {
      buttonsConfig.createOrder = async () => {
        if (!this.currentContext) throw new Error("No context");
        const intent = await this.currentHandlers.onConfirm(
          this.currentContext
        );
        return intent.clientSecret;
      };
      buttonsConfig.onApprove = async (data) => {
        if (!data.orderID) return;
        if (typeof window === "undefined" || !handlers.successUrl) return;
        const overlay = this.showCaptureOverlay();
        try {
          let capturedEmail = this.currentContext?.donor.email;
          let capturedName = this.currentContext?.donor.name;
          if (handlers.onCapture) {
            try {
              const captureResult = await handlers.onCapture(data.orderID);
              if (captureResult.payerEmail) capturedEmail = captureResult.payerEmail;
              if (captureResult.payerName) capturedName = captureResult.payerName;
            } catch (err) {
              console.error("[PaypalProvider] capture failed:", err);
              this.signaler("bouton.encaissement", err, "avertissement", data.orderID);
              overlay?.remove();
              throw err;
            }
          }
          const url = this.buildReturnUrl(
            handlers.successUrl(capturedEmail),
            capturedEmail,
            data.orderID,
            "paypal_order_id"
          );
          const finalUrl = capturedName ? `${url}${url.includes("?") ? "&" : "?"}paypal_payer_name=${encodeURIComponent(capturedName)}` : url;
          window.location.href = finalUrl;
        } catch (err) {
          overlay?.remove();
          throw err;
        }
      };
    }
    this.buttonsInstance = this.sdk.Buttons(buttonsConfig);
    if (!this.buttonsInstance.isEligible()) {
      console.warn("[PaypalProvider] Buttons not eligible \u2014 skipping render");
      return;
    }
    await this.waitForElement(containerId);
    await this.buttonsInstance.render(`#${containerId}`);
  }
  async updateExpressCheckout(context) {
    this.currentContext = context;
  }
  async mountCardForm(containerId, _options, onCapture) {
    if (!this.sdk) throw new Error("PayPal non initialis\xE9");
    await this.waitForElement(containerId);
    const container = document.getElementById(containerId);
    if (!container) {
      throw new Error(`Container #${containerId} introuvable`);
    }
    const fieldIds = {
      number: `${containerId}-number`,
      expiry: `${containerId}-expiry`,
      cvv: `${containerId}-cvv`
    };
    const focusStyleId = `${containerId}-focus-style`;
    if (!document.getElementById(focusStyleId)) {
      const style = document.createElement("style");
      style.id = focusStyleId;
      style.textContent = `
        #${containerId} { background: transparent; }
        /* Iframes Zoid occupent 100% de leur wrapper, hauteur 48px pour
           matcher la respiration verticale de Stripe (texte ~16px centr\xE9
           dans une bo\xEEte ~48px). */
        [id^="${containerId}-"] iframe {
          width: 100% !important;
          height: 48px !important;
          min-height: 48px !important;
          padding: 0 !important;
          margin: 0 !important;
        }
        [id^="${containerId}-"] [id^="zoid-paypal-card-"] {
          height: 48px !important;
          min-height: 48px !important;
          padding: 0 !important;
          margin: 0 !important;
        }
        /* Wrapper parent passe en rouge quand au moins un CardField est
           "definitively invalid" (luhn fail, num\xE9ro trop long, etc).
           Border rouge uniquement \u2014 pas de halo shadow. */
        :has(> #${containerId}[data-cardfields-invalid="true"]) {
          border-color: #ef4444 !important;
          box-shadow: none !important;
        }
      `;
      document.head.appendChild(style);
    }
    container.innerHTML = `
      <div style="display:flex;align-items:center;gap:12px;">
        <div id="${fieldIds.number}" style="flex:1 1 auto;min-width:0;"></div>
        <div id="${fieldIds.expiry}" style="flex:0 0 92px;min-width:0;"></div>
        <div id="${fieldIds.cvv}" style="flex:0 0 54px;min-width:0;"></div>
      </div>
    `;
    const cardFieldsConfig = {
      // Events temps réel : on update notre state + on flag le wrapper
      // externe comme "invalide" pour déclencher le style rouge via CSS.
      // `isPotentiallyValid` reste true tant que l'utilisateur peut encore
      // arriver à un état valide (ex: 4 chiffres tapés → potentiel mais pas
      // encore valid). On ne marque "invalide" QUE si isPotentiallyValid:false
      // (ex: numéro trop long / luhn check fail) ou au blur.
      inputEvents: {
        onChange: (state) => {
          const f = state.fields;
          this.cardFieldsValidity = {
            isFormValid: state.isFormValid ?? false,
            number: {
              isValid: f.cardNumberField.isValid,
              isPotentiallyValid: f.cardNumberField.isPotentiallyValid ?? true
            },
            expiry: {
              isValid: f.cardExpiryField.isValid,
              isPotentiallyValid: f.cardExpiryField.isPotentiallyValid ?? true
            },
            cvv: {
              isValid: f.cardCvvField.isValid,
              isPotentiallyValid: f.cardCvvField.isPotentiallyValid ?? true
            }
          };
          this.applyCardFieldsValidityStyles(containerId);
          this.cardFieldsValidityListeners.forEach(
            (cb) => cb(this.cardFieldsValidity)
          );
        },
        onBlur: () => {
          this.applyCardFieldsValidityStyles(containerId);
        }
      },
      style: {
        // Styles INTERNES aux iframes (sandbox). Mode "inline Stripe-like" :
        // les iframes n'ont PAS de border (le wrapper externe la dessine),
        // background transparent, padding réduit. Seul le texte/font est
        // stylé ici. Cf. memory/paypal_capabilities_2026.md.
        input: {
          "font-size": "16px",
          "font-family": "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif",
          "font-weight": "400",
          color: "#0f172a",
          height: "48px",
          padding: "0",
          "padding-left": "0",
          "padding-right": "0",
          "padding-top": "0",
          "padding-bottom": "0",
          margin: "0",
          "line-height": "48px",
          border: "none",
          background: "transparent",
          outline: "none"
        },
        ":focus": {
          color: "#0f172a",
          border: "none",
          outline: "none",
          "box-shadow": "none",
          background: "transparent"
        },
        ".invalid": {
          color: "#0f172a",
          border: "none",
          outline: "none",
          "box-shadow": "none",
          background: "transparent"
        },
        ":invalid": {
          color: "#0f172a",
          border: "none",
          outline: "none",
          "box-shadow": "none",
          background: "transparent"
        },
        ".invalid:focus": {
          color: "#0f172a",
          border: "none",
          outline: "none",
          "box-shadow": "none",
          background: "transparent"
        },
        ":focus:invalid": {
          color: "#0f172a",
          border: "none",
          outline: "none",
          "box-shadow": "none",
          background: "transparent"
        },
        "::placeholder": { color: "#94a3b8" }
      },
      createOrder: async () => {
        if (!this.currentContext || !this.currentHandlers)
          throw new Error("No context");
        const intent = await this.currentHandlers.onConfirm(
          this.currentContext
        );
        return intent.clientSecret;
      },
      onApprove: async (data) => {
        if (typeof window === "undefined" || !this.currentHandlers?.successUrl) {
          return;
        }
        if (!data.orderID) return;
        const overlay = this.showCaptureOverlay();
        try {
          let capturedEmail = this.currentContext?.donor.email;
          let capturedName = this.currentContext?.donor.name;
          if (onCapture) {
            try {
              const captureResult = await onCapture(data.orderID);
              if (captureResult.payerEmail) capturedEmail = captureResult.payerEmail;
              if (captureResult.payerName) capturedName = captureResult.payerName;
            } catch (err) {
              console.error("[PaypalProvider/CardFields] capture failed:", err);
              this.signaler("carte.encaissement", err, "avertissement", data.orderID);
              this.derniereErreurCapture = err instanceof Error && err.message ? err.message : null;
              overlay?.remove();
              throw err;
            }
          }
          const url = this.buildReturnUrl(
            this.currentHandlers.successUrl(capturedEmail),
            capturedEmail,
            data.orderID,
            "paypal_order_id"
          );
          const finalUrl = capturedName ? `${url}${url.includes("?") ? "&" : "?"}paypal_payer_name=${encodeURIComponent(capturedName)}` : url;
          window.location.href = finalUrl;
        } catch (err) {
          overlay?.remove();
          throw err;
        }
      },
      onError: (err) => {
        console.error("[PaypalProvider] CardFields onError:", err);
        this.signaler("carte.sdk", err, "erreur");
      }
    };
    this.cardFieldsInstance = this.sdk.CardFields(cardFieldsConfig);
    if (!this.cardFieldsInstance.isEligible()) {
      container.innerHTML = "";
      this.cardFieldsInstance = null;
      const err = new Error(
        "PayPal CardFields not eligible \u2014 utilisez le bouton PayPal"
      );
      err.code = "PAYPAL_CARDFIELDS_NOT_ELIGIBLE";
      throw err;
    }
    await Promise.all([
      this.cardFieldsInstance.NumberField({ placeholder: "Num\xE9ro de carte" }).render(`#${fieldIds.number}`),
      this.cardFieldsInstance.ExpiryField({ placeholder: "MM / AA" }).render(`#${fieldIds.expiry}`),
      this.cardFieldsInstance.CVVField({ placeholder: "CVC" }).render(`#${fieldIds.cvv}`)
    ]);
  }
  /**
   * Monte un bouton **Apple Pay via PayPal** dans un conteneur DOM.
   *
   * Le SDK PayPal v6 expose `paypal.Applepay()` qui s'appuie sur l'API
   * native `window.ApplePaySession` (Safari iOS/macOS uniquement). Notre
   * implémentation rend un bouton HTML standard Apple Pay (`<apple-pay-button>`)
   * puis attache un click handler qui :
   *   1. Crée un order PayPal côté backend (via `handlers.onConfirm`).
   *   2. Ouvre un `ApplePaySession` natif (sheet wallet iOS).
   *   3. Sur `onvalidatemerchant` : appelle `applepay.validateMerchant()`
   *      pour obtenir une `merchantSession` Apple → completeMerchantValidation.
   *   4. Sur `onpaymentauthorized` : appelle `applepay.confirmOrder()` avec
   *      le token Apple Pay reçu → complete + redirect vers successUrl.
   *
   * ⚠️ NÉCESSITE :
   *   - Safari iOS/macOS (Chrome/Firefox = no-op silencieux)
   *   - Org PayPal éligible Apple Pay (capability `APPLE_PAY` + domaine
   *     vérifié dans le dashboard PayPal Merchant > Apple Pay)
   *   - HTTPS (Apple Pay refuse HTTP même en localhost)
   *
   * Si non éligible, throw `PAYPAL_APPLEPAY_NOT_ELIGIBLE` (intercepté par
   * l'UI pour cacher le bouton silencieusement).
   *
   * Karim 2026-06-21 : pendant client du `mountExpressCheckout` Stripe pour
   * que les pages publiques puissent choisir leur wallet provider selon
   * `payment_providers.preferred_provider`.
   */
  async mountApplePay(containerId, handlers, initialContext) {
    if (!this.sdk) throw new Error("PayPal non initialis\xE9");
    if (typeof window === "undefined") return;
    this.currentHandlers = handlers;
    this.currentContext = initialContext;
    if (!this.sdk.Applepay) {
      const err = new Error("PayPal SDK Applepay component not loaded");
      err.code = "PAYPAL_APPLEPAY_NOT_ELIGIBLE";
      throw err;
    }
    const applepay = this.sdk.Applepay();
    const cfg = await applepay.config();
    const sessionOk = window.ApplePaySession?.canMakePayments?.() === true;
    if (!cfg.isEligible || !sessionOk) {
      const err = new Error("Apple Pay non disponible sur ce device/compte");
      err.code = "PAYPAL_APPLEPAY_NOT_ELIGIBLE";
      throw err;
    }
    await this.waitForElement(containerId);
    const container = document.getElementById(containerId);
    container.innerHTML = `
      <apple-pay-button
        buttonstyle="black"
        type="pay"
        locale="${this.locale.split("_")[0] || "fr"}"
        style="--apple-pay-button-width: 100%; --apple-pay-button-height: 44px; --apple-pay-button-border-radius: 6px;"
      ></apple-pay-button>
    `;
    void avecReessais(
      () => chargerScript("donoor-applepay-sdk", "https://applepay.cdn-apple.com/jsapi/v1/apple-pay-sdk.js"),
      (err) => err instanceof EchecChargementScript
    ).catch((err) => {
      signalerErreurPaiement({ provider: "paypal", etape: "applepay.sdk", erreur: err, gravite: "erreur" });
    });
    const button = container.querySelector("apple-pay-button");
    if (!button) return;
    button.addEventListener("click", () => {
      const AppleSession = window.ApplePaySession;
      if (!AppleSession) return;
      const amountToCharge = Number(this.currentContext?.amount ?? 0);
      const paymentRequest = {
        countryCode: cfg.countryCode || "FR",
        currencyCode: cfg.currencyCode || this.currency,
        merchantCapabilities: cfg.merchantCapabilities || ["supports3DS"],
        supportedNetworks: cfg.supportedNetworks || ["visa", "masterCard", "amex"],
        requiredBillingContactFields: ["postalAddress", "name"],
        requiredShippingContactFields: ["email"],
        total: {
          label: "Donoor",
          amount: amountToCharge.toFixed(2),
          type: "final"
        }
      };
      const session = new AppleSession(4, paymentRequest);
      let orderId = null;
      session.onvalidatemerchant = async (event) => {
        try {
          const intent = await handlers.onConfirm(this.currentContext);
          orderId = intent.clientSecret;
          const { merchantSession } = await applepay.validateMerchant({
            validationUrl: event.validationURL,
            displayName: "Donoor"
          });
          session.completeMerchantValidation(merchantSession);
        } catch (err) {
          console.error("[PaypalProvider/ApplePay] validateMerchant failed:", err);
          this.signaler("apple_pay.ouverture", err, "erreur", orderId ?? void 0);
          session.abort();
        }
      };
      session.onpaymentauthorized = async (event) => {
        if (!orderId) {
          console.error("[PaypalProvider/ApplePay] orderId manquant (onConfirm a \xE9chou\xE9)");
          session.completePayment({ status: AppleSession.STATUS_FAILURE });
          return;
        }
        try {
          const result = await applepay.confirmOrder({
            orderId,
            billingContact: event.payment.billingContact,
            shippingContact: event.payment.shippingContact,
            token: event.payment.token
          });
          const ok = result?.approveApplePayPayment?.status === "APPROVED" || result?.status === "APPROVED";
          if (!ok) {
            this.signaler(
              "apple_pay.confirmation",
              // Statut seul : jamais la réponse entière (contacts du donateur).
              new Error(
                `Apple Pay : commande non approuv\xE9e (statut ${result?.approveApplePayPayment?.status ?? result?.status ?? "aucun"})`
              ),
              "erreur",
              orderId
            );
            session.completePayment({ status: AppleSession.STATUS_FAILURE });
            return;
          }
          const overlay = this.showCaptureOverlay();
          let capturedEmail = this.currentContext?.donor.email;
          let capturedName = this.currentContext?.donor.name;
          if (handlers.onCapture) {
            try {
              const r = await handlers.onCapture(orderId);
              if (r.payerEmail) capturedEmail = r.payerEmail;
              if (r.payerName) capturedName = r.payerName;
            } catch (err) {
              console.error("[PaypalProvider/ApplePay] capture failed:", err);
              this.signaler("apple_pay.encaissement", err, "avertissement", orderId);
              overlay?.remove();
              session.completePayment({ status: AppleSession.STATUS_FAILURE });
              handlers.onError?.(err);
              return;
            }
          }
          session.completePayment({ status: AppleSession.STATUS_SUCCESS });
          const url = this.buildReturnUrl(
            handlers.successUrl(capturedEmail),
            capturedEmail,
            orderId,
            "paypal_order_id"
          );
          const finalUrl = capturedName ? `${url}${url.includes("?") ? "&" : "?"}paypal_payer_name=${encodeURIComponent(capturedName)}` : url;
          window.location.href = finalUrl;
          void overlay;
        } catch (err) {
          console.error("[PaypalProvider/ApplePay] confirmOrder failed:", err);
          this.signaler("apple_pay.confirmation", err, "erreur", orderId);
          session.completePayment({ status: AppleSession.STATUS_FAILURE });
        }
      };
      session.oncancel = () => {
      };
      session.begin();
    });
  }
  /**
   * Monte un bouton **Google Pay via PayPal** dans un conteneur DOM.
   *
   * Le SDK PayPal v6 expose `paypal.Googlepay()`. Notre implémentation :
   *   1. Charge le SDK Google Pay `pay.js` (CDN officiel google).
   *   2. Initialise un `google.payments.api.PaymentsClient` avec
   *      l'environnement (`PRODUCTION` ou `TEST`) déduit de `paypal.live`.
   *   3. Vérifie `isReadyToPay` → si false, throw NOT_ELIGIBLE.
   *   4. Rend un bouton Google Pay officiel (createButton).
   *   5. Au click : `loadPaymentData()` (sheet Google Pay) → `confirmOrder()`
   *      PayPal avec le `paymentMethodData` reçu.
   *
   * ⚠️ NÉCESSITE :
   *   - Org PayPal éligible Google Pay (capability `GOOGLE_PAY` activée)
   *   - HTTPS (Google Pay refuse HTTP en prod)
   *
   * Si non éligible, throw `PAYPAL_GOOGLEPAY_NOT_ELIGIBLE`.
   */
  async mountGooglePay(containerId, handlers, initialContext) {
    if (!this.sdk) throw new Error("PayPal non initialis\xE9");
    if (typeof window === "undefined") return;
    this.currentHandlers = handlers;
    this.currentContext = initialContext;
    if (!this.sdk.Googlepay) {
      const err = new Error("PayPal SDK Googlepay component not loaded");
      err.code = "PAYPAL_GOOGLEPAY_NOT_ELIGIBLE";
      throw err;
    }
    const googlepay = this.sdk.Googlepay();
    const cfg = await googlepay.config();
    if (!Array.isArray(cfg.allowedPaymentMethods) || cfg.allowedPaymentMethods.length === 0) {
      const err = new Error("Google Pay non disponible pour ce compte");
      err.code = "PAYPAL_GOOGLEPAY_NOT_ELIGIBLE";
      throw err;
    }
    await this.loadGooglePaySdk();
    const GoogleApi = window.google?.payments?.api;
    if (!GoogleApi) {
      const err = new Error("Google Pay SDK indisponible");
      err.code = "PAYPAL_GOOGLEPAY_NOT_ELIGIBLE";
      throw err;
    }
    const isProd = typeof window !== "undefined" && !/(localhost|127\.0\.0\.1|staging|test)/.test(window.location.hostname);
    const client = new GoogleApi.PaymentsClient({
      environment: isProd ? "PRODUCTION" : "TEST"
    });
    const baseRequest = {
      apiVersion: cfg.apiVersion ?? 2,
      apiVersionMinor: cfg.apiVersionMinor ?? 0
    };
    const isReady = await client.isReadyToPay({
      ...baseRequest,
      allowedPaymentMethods: cfg.allowedPaymentMethods
    });
    if (!isReady.result) {
      const err = new Error("Google Pay non disponible sur ce device");
      err.code = "PAYPAL_GOOGLEPAY_NOT_ELIGIBLE";
      throw err;
    }
    await this.waitForElement(containerId);
    const container = document.getElementById(containerId);
    container.innerHTML = "";
    const button = client.createButton({
      onClick: async () => {
        if (handlers.onClick) {
          const allowed = await handlers.onClick();
          if (!allowed) return;
        }
        const amountToCharge = Number(this.currentContext?.amount ?? 0);
        const paymentDataRequest = {
          ...baseRequest,
          allowedPaymentMethods: cfg.allowedPaymentMethods,
          merchantInfo: cfg.merchantInfo || { merchantName: "Donoor" },
          transactionInfo: {
            countryCode: cfg.countryCode || "FR",
            currencyCode: this.currency,
            totalPriceStatus: "FINAL",
            totalPrice: amountToCharge.toFixed(2)
          }
        };
        let orderId;
        let encaisse = false;
        try {
          const paymentData = await client.loadPaymentData(paymentDataRequest);
          const intent = await handlers.onConfirm(this.currentContext);
          orderId = intent.clientSecret;
          const result = await googlepay.confirmOrder({
            orderId,
            paymentMethodData: paymentData.paymentMethodData
          });
          const statut = result?.status;
          if (statut === "PAYER_ACTION_REQUIRED") {
            await googlepay.initiatePayerAction({ orderId });
          } else if (statut !== "APPROVED") {
            console.error("[PaypalProvider/GooglePay] confirmOrder not approved:", statut);
            this.signaler(
              "google_pay.confirmation",
              new Error(`Google Pay : statut inattendu ${statut ?? "(aucun)"}`),
              "erreur",
              orderId
            );
            handlers.onError?.(new Error(textePaiement(this.locale, "googlePayEchec")));
            return;
          }
          const overlay = this.showCaptureOverlay();
          let capturedEmail = this.currentContext?.donor.email;
          let capturedName = this.currentContext?.donor.name;
          if (handlers.onCapture) {
            try {
              const r = await handlers.onCapture(orderId);
              if (r.payerEmail) capturedEmail = r.payerEmail;
              if (r.payerName) capturedName = r.payerName;
            } catch (err) {
              console.error("[PaypalProvider/GooglePay] capture failed:", err);
              this.signaler("google_pay.encaissement", err, "avertissement", orderId);
              overlay?.remove();
              handlers.onError?.(err);
              return;
            }
          }
          encaisse = true;
          const url = this.buildReturnUrl(
            handlers.successUrl(capturedEmail),
            capturedEmail,
            orderId,
            "paypal_order_id"
          );
          const finalUrl = capturedName ? `${url}${url.includes("?") ? "&" : "?"}paypal_payer_name=${encodeURIComponent(capturedName)}` : url;
          window.location.href = finalUrl;
          void overlay;
        } catch (err) {
          const e = err;
          if (e?.statusCode === "CANCELED") return;
          console.error("[PaypalProvider/GooglePay] loadPaymentData failed:", err);
          this.signaler("google_pay.confirmation", err, "erreur", orderId);
          if (encaisse) return;
          handlers.onError?.(orderId ? new Error(textePaiement(this.locale, "googlePayEchec")) : err);
        }
      },
      buttonColor: "default",
      buttonType: "pay",
      buttonSizeMode: "fill",
      // Locale du libellé : sans ça Google Pay s'affiche en anglais
      // (« Pay with G Pay »). On dérive le code 2 lettres de la locale du
      // provider (« fr_FR » → « fr »), défaut « fr ».
      buttonLocale: (this.locale || "fr_FR").split(/[_-]/)[0] || "fr"
    });
    container.appendChild(button);
  }
  /**
   * Charge le SDK Google Pay (`pay.js`) une seule fois. Idempotent.
   */
  async loadGooglePaySdk() {
    if (typeof window === "undefined") return;
    const w = window;
    if (w.google?.payments) return;
    await avecReessais(
      () => chargerScript("donoor-googlepay-sdk", "https://pay.google.com/gp/p/js/pay.js"),
      (err) => err instanceof EchecChargementScript
    );
  }
  async confirmCardPayment(context, createPaymentIntent, successUrl) {
    if (!this.cardFieldsInstance) {
      return {
        error: { message: "CardFields non mont\xE9", type: "validation_error" }
      };
    }
    if (!this.cardFieldsValidity.isFormValid) {
      const v = this.cardFieldsValidity;
      let message = "V\xE9rifiez les informations de votre carte bancaire et r\xE9essayez.";
      if (!v.number.isValid) {
        message = "Le num\xE9ro de carte est invalide ou incomplet.";
      } else if (!v.expiry.isValid) {
        message = "La date d'expiration est invalide (format MM/AA).";
      } else if (!v.cvv.isValid) {
        message = "Le code de s\xE9curit\xE9 (CVC) est invalide ou incomplet.";
      }
      return { error: { message, type: "validation_error" } };
    }
    this.currentContext = context;
    if (!this.currentHandlers) {
      this.currentHandlers = {
        onConfirm: createPaymentIntent,
        successUrl
      };
    }
    this.derniereErreurCapture = null;
    try {
      await this.cardFieldsInstance.submit({
        // Nom du titulaire passé directement (capturé en amont via DonateDonorForm,
        // pas via un NameField PayPal redondant).
        cardholderName: context.donor.name || void 0,
        billingAddress: context.donor.address ? {
          addressLine1: context.donor.address.line1,
          addressLine2: context.donor.address.line2,
          adminArea2: context.donor.address.city,
          postalCode: context.donor.address.postal_code,
          countryCode: context.donor.address.country
        } : void 0
      });
      const refus = this.derniereErreurCapture;
      this.derniereErreurCapture = null;
      return refus ? { error: { message: refus, type: "card_error" } } : {};
    } catch (err) {
      const refus = this.derniereErreurCapture;
      this.derniereErreurCapture = null;
      if (refus) return { error: { message: refus, type: "card_error" } };
      const rawMessage = err instanceof Error ? err.message : String(err ?? "");
      this.signaler("carte.validation", err, "avertissement");
      const message = mapPaypalCardErrorMessage(rawMessage, this.locale);
      return { error: { message, type: "card_error" } };
    }
  }
  async confirmSubscription(_context, _handlers, _successUrl) {
    return {
      error: {
        message: "Le don r\xE9current par carte via PayPal sera disponible prochainement. Utilisez le bouton PayPal pour un abonnement avec compte PayPal.",
        type: "validation_error"
      }
    };
  }
  destroyExpressCheckout() {
    try {
      this.buttonsInstance?.close();
    } catch {
    }
    this.buttonsInstance = null;
  }
  destroy() {
    this.destroyExpressCheckout();
    this.cardFieldsInstance = null;
    this.currentContext = null;
    this.currentHandlers = null;
  }
  /**
   * Retourne l'état de validité courant des CardFields. Le composant Vue
   * peut appeler ça après chaque changement pour griser le bouton "Payer"
   * quand `isFormValid === false`.
   */
  getCardFieldsValidity() {
    return this.cardFieldsValidity;
  }
  /**
   * Souscrit à un callback déclenché à chaque changement de validité des
   * CardFields. Retourne une fonction `unsubscribe`. À utiliser par le
   * composant Vue pour mettre à jour son state réactif et griser le bouton.
   */
  onCardFieldsValidityChange(cb) {
    this.cardFieldsValidityListeners.add(cb);
    return () => {
      this.cardFieldsValidityListeners.delete(cb);
    };
  }
  /**
   * Applique le style "invalide" (bordure rouge + halo rouge) au wrapper
   * externe quand au moins un field a `isPotentiallyValid: false`. Utilise
   * un data-attribute sur le container pour permettre au CSS Tailwind ou
   * inline de styler le `:has([data-invalid="true"])` du wrapper.
   */
  applyCardFieldsValidityStyles(containerId) {
    if (typeof document === "undefined") return;
    const container = document.getElementById(containerId);
    if (!container) return;
    const v = this.cardFieldsValidity;
    const hasInvalid = v.number.isPotentiallyValid === false || v.expiry.isPotentiallyValid === false || v.cvv.isPotentiallyValid === false;
    container.setAttribute("data-cardfields-invalid", hasInvalid ? "true" : "false");
  }
  // ===========================================================================
  // Helpers
  // ===========================================================================
  /** Signale une erreur de paiement, une seule fois par erreur. */
  signaler(etape, erreur, gravite, orderId) {
    if (erreur && typeof erreur === "object") {
      if (this.erreursSignalees.has(erreur)) return;
      this.erreursSignalees.add(erreur);
    }
    signalerErreurPaiement({ provider: "paypal", etape, erreur, gravite, orderId });
  }
  /**
   * Affiche un overlay full-screen "Finalisation de votre don..." pendant
   * la capture PayPal côté serveur. Injecté en `document.body` car le DOM
   * autour du bouton PayPal est dans des iframes sandboxées que Vue ne
   * contrôle pas.
   *
   * Style cohérent avec l'UX Donoor (fond blanc semi-opaque + spinner bleu
   * + texte rassurant). Retourne l'élément pour pouvoir le retirer.
   */
  showCaptureOverlay() {
    if (typeof document === "undefined") return null;
    const overlay = document.createElement("div");
    overlay.setAttribute("data-donoor-paypal-overlay", "true");
    overlay.style.cssText = `
      position: fixed;
      inset: 0;
      background: rgba(255, 255, 255, 0.92);
      backdrop-filter: blur(4px);
      -webkit-backdrop-filter: blur(4px);
      z-index: 999999;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 16px;
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
      color: #111827;
      animation: donoor-paypal-overlay-fade 200ms ease-out;
    `;
    overlay.innerHTML = `
      <style>
        @keyframes donoor-paypal-overlay-fade {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        @keyframes donoor-paypal-spin {
          to { transform: rotate(360deg); }
        }
      </style>
      <div style="
        width: 48px;
        height: 48px;
        border: 4px solid #E5E7EB;
        border-top-color: #0070BA;
        border-radius: 50%;
        animation: donoor-paypal-spin 800ms linear infinite;
      "></div>
      <div style="font-size: 17px; font-weight: 600; text-align: center;">
        Finalisation de votre don\u2026
      </div>
      <div style="font-size: 14px; color: #6B7280; text-align: center; max-width: 320px; padding: 0 16px;">
        Nous traitons votre paiement avec PayPal en toute s\xE9curit\xE9.
        Ne fermez pas cette fen\xEAtre.
      </div>
    `;
    document.body.appendChild(overlay);
    return overlay;
  }
  buildReturnUrl(baseUrl, donorEmail, extraIdValue, extraIdKey) {
    try {
      const url = new URL(
        baseUrl,
        typeof window !== "undefined" ? window.location.origin : "https://localhost"
      );
      if (donorEmail && !url.searchParams.get("email")) {
        url.searchParams.set("email", donorEmail);
      }
      if (extraIdKey && extraIdValue && !url.searchParams.get(extraIdKey)) {
        url.searchParams.set(extraIdKey, extraIdValue);
      }
      return url.toString();
    } catch {
      const sep = baseUrl.includes("?") ? "&" : "?";
      const parts = [
        donorEmail ? `email=${encodeURIComponent(donorEmail)}` : "",
        extraIdKey && extraIdValue ? `${extraIdKey}=${extraIdValue}` : ""
      ].filter(Boolean);
      return parts.length ? `${baseUrl}${sep}${parts.join("&")}` : baseUrl;
    }
  }
  async waitForElement(id, timeoutMs = 5e3) {
    const start = Date.now();
    return new Promise((resolve, reject) => {
      const tick = () => {
        const el = document.getElementById(id);
        if (el) return resolve(el);
        if (Date.now() - start > timeoutMs) {
          return reject(
            new Error(`Element #${id} not found in DOM after ${timeoutMs}ms`)
          );
        }
        requestAnimationFrame(tick);
      };
      tick();
    });
  }
};

// src/useCheckout.ts
function useCheckout(opts) {
  const status = ref("idle");
  const error = ref(null);
  const availability = ref({
    applePay: false,
    googlePay: false,
    link: false,
    paypal: false
  });
  const isProcessing = ref(false);
  const isInitialized = ref(false);
  const expressCheckoutReady = ref(false);
  const cardFormError = ref(null);
  const expressCheckoutError = ref(null);
  const cardMounted = ref(false);
  const cardFieldsValidity = ref({
    isFormValid: true,
    number: { isValid: false, isPotentiallyValid: true },
    expiry: { isValid: false, isPotentiallyValid: true },
    cvv: { isValid: false, isPotentiallyValid: true }
  });
  let unsubscribeValidity = null;
  const provider = opts.provider === "paypal" ? new PaypalProvider() : new StripeProvider();
  if (opts.provider === "paypal") {
    cardFieldsValidity.value.isFormValid = false;
  }
  let initialized = false;
  function buildContext() {
    return {
      amount: opts.amount.value,
      currency: opts.currency ?? "eur",
      donor: opts.donor.value,
      feesCovered: opts.feesCovered?.value ?? null,
      recurring: opts.recurring?.value ?? null,
      metadata: opts.metadata?.value
    };
  }
  function resolveConnectedAccountId() {
    const raw = opts.connectedAccountId;
    if (raw == null) return void 0;
    let val;
    if (typeof raw === "string") {
      val = raw;
    } else if (typeof raw === "function") {
      val = raw();
    } else {
      val = raw.value;
    }
    return val || void 0;
  }
  async function awaitConnectedAccountId(timeoutMs = 8e3) {
    const immediate = resolveConnectedAccountId();
    if (immediate) return immediate;
    return await new Promise((resolve) => {
      const start = Date.now();
      let settled = false;
      let stopWatch = null;
      let tick = null;
      const finish = (val) => {
        if (settled) return;
        settled = true;
        if (stopWatch) stopWatch();
        if (tick) clearInterval(tick);
        resolve(val);
      };
      stopWatch = watch(
        () => resolveConnectedAccountId(),
        (val) => {
          if (val) finish(val);
        }
      );
      tick = setInterval(() => {
        const val = resolveConnectedAccountId();
        if (val || Date.now() - start >= timeoutMs) finish(val);
      }, 100);
    });
  }
  let initEnCours = null;
  let generationInit = 0;
  async function ensureInit() {
    if (initialized) return;
    if (!initEnCours) {
      const generation = generationInit;
      initEnCours = (async () => {
        const connectedAccountId = await awaitConnectedAccountId();
        await provider.init({
          publicKey: opts.publicKey,
          connectedAccountId,
          currency: opts.currency,
          locale: opts.locale,
          partnerAttributionId: opts.partnerAttributionId,
          pageType: opts.pageType,
          sandbox: opts.sandbox
        });
        if (generation !== generationInit) return;
        initialized = true;
        isInitialized.value = true;
        status.value = "ready";
      })().finally(() => {
        if (generation === generationInit) initEnCours = null;
      });
    }
    return initEnCours;
  }
  function signalerErreurWallet(err) {
    const e = {
      message: err instanceof Error ? err.message : textePaiement(opts.locale, "paiementRefuse"),
      type: "wallet_error"
    };
    error.value = e;
    opts.onError?.(e);
  }
  let conteneurExpress = null;
  async function mountExpressCheckout(containerId) {
    conteneurExpress = containerId;
    expressCheckoutError.value = null;
    try {
      await ensureInit();
      await provider.mountExpressCheckout(
        containerId,
        {
          onClick: opts.onClick,
          onConfirm: async (ctx) => {
            isProcessing.value = true;
            try {
              return await opts.createPaymentIntent(ctx);
            } finally {
              isProcessing.value = false;
            }
          },
          successUrl: opts.successUrl,
          onCapture: opts.onCapture,
          onError: signalerErreurWallet
        },
        buildContext()
      );
      availability.value = await provider.detectAvailability();
      expressCheckoutReady.value = true;
    } catch (err) {
      const e = {
        message: err instanceof Error ? err.message : "Erreur init checkout",
        type: "unknown"
      };
      expressCheckoutError.value = e;
      error.value = e;
      status.value = "error";
      opts.onError?.(e);
    }
  }
  async function mountApplePay(containerId) {
    try {
      await ensureInit();
      if (typeof provider.mountApplePay !== "function") {
        return;
      }
      await provider.mountApplePay(
        containerId,
        {
          onClick: opts.onClick,
          onConfirm: async (ctx) => {
            isProcessing.value = true;
            try {
              return await opts.createPaymentIntent(ctx);
            } finally {
              isProcessing.value = false;
            }
          },
          successUrl: opts.successUrl,
          onCapture: opts.onCapture,
          onError: signalerErreurWallet
        },
        buildContext()
      );
    } catch (err) {
      const codedErr = err;
      const e = {
        message: err instanceof Error ? err.message : "Erreur init Apple Pay",
        type: "unknown",
        ...codedErr.code ? { code: codedErr.code } : {}
      };
      throw e;
    }
  }
  async function mountGooglePay(containerId) {
    try {
      await ensureInit();
      if (typeof provider.mountGooglePay !== "function") {
        return;
      }
      await provider.mountGooglePay(
        containerId,
        {
          onClick: opts.onClick,
          onConfirm: async (ctx) => {
            isProcessing.value = true;
            try {
              return await opts.createPaymentIntent(ctx);
            } finally {
              isProcessing.value = false;
            }
          },
          successUrl: opts.successUrl,
          onCapture: opts.onCapture,
          onError: signalerErreurWallet
        },
        buildContext()
      );
    } catch (err) {
      const codedErr = err;
      const e = {
        message: err instanceof Error ? err.message : "Erreur init Google Pay",
        type: "unknown",
        ...codedErr.code ? { code: codedErr.code } : {}
      };
      throw e;
    }
  }
  async function mountCardForm(containerId, options) {
    cardFormError.value = null;
    error.value = null;
    if (status.value === "error") status.value = isInitialized.value ? "ready" : "idle";
    cardMounted.value = false;
    try {
      await ensureInit();
      await provider.mountCardForm(containerId, options, opts.onCapture);
      if (opts.provider === "paypal") {
        const p = provider;
        if (typeof p.onCardFieldsValidityChange === "function") {
          unsubscribeValidity = p.onCardFieldsValidityChange((v) => {
            cardFieldsValidity.value = v;
            options?.onCardChange?.();
          });
        }
      }
      cardMounted.value = true;
      return true;
    } catch (err) {
      const codedErr = err;
      const e = {
        message: err instanceof Error ? err.message : "Erreur mount carte",
        type: "unknown",
        ...codedErr.code ? { code: codedErr.code } : {}
      };
      cardFormError.value = e;
      error.value = e;
      status.value = "error";
      opts.onError?.(e);
      return false;
    }
  }
  async function confirmCardPayment() {
    error.value = null;
    isProcessing.value = true;
    status.value = "processing";
    try {
      const result = await provider.confirmCardPayment(
        buildContext(),
        opts.createPaymentIntent,
        opts.successUrl
      );
      if (result.error) {
        error.value = result.error;
        status.value = "error";
        opts.onError?.(result.error);
      } else {
        status.value = "success";
      }
      return result;
    } finally {
      isProcessing.value = false;
    }
  }
  async function confirmerMoyenLocal(moyen, options = {}) {
    if (!provider.confirmerMoyenLocal) {
      const err = { message: "Moyen de paiement indisponible", type: "validation_error" };
      error.value = err;
      return { error: err };
    }
    error.value = null;
    isProcessing.value = true;
    status.value = "processing";
    try {
      await ensureInit();
      const contexte = buildContext();
      const nom = options.nomTitulaire?.trim();
      const avecNom = nom ? { ...contexte, donor: { ...contexte.donor, name: nom } } : contexte;
      const result = await provider.confirmerMoyenLocal(moyen, avecNom, opts.createPaymentIntent, opts.successUrl);
      if (result.error) {
        error.value = result.error;
        status.value = "error";
        opts.onError?.(result.error);
      }
      return result;
    } finally {
      isProcessing.value = false;
    }
  }
  let prelevementMensuel = false;
  async function monterPrelevementSepa(conteneur, options) {
    if (!provider.monterPrelevementSepa) return false;
    await ensureInit();
    prelevementMensuel = options.mensuel;
    return provider.monterPrelevementSepa(conteneur, {
      montantCentimes: Math.round((opts.amount.value || 0) * 100),
      mensuel: options.mensuel
    });
  }
  function demonterPrelevementSepa() {
    provider.demonterPrelevementSepa?.();
  }
  watch(
    () => opts.amount.value,
    (montant) => provider.mettreAJourPrelevementSepa?.(Math.round((montant || 0) * 100))
  );
  async function confirmerPrelevementSepa(options = {}) {
    error.value = null;
    isProcessing.value = true;
    status.value = "processing";
    try {
      const contexte = buildContext();
      const nom = options.nomTitulaire?.trim();
      const avecNom = nom ? { ...contexte, donor: { ...contexte.donor, name: nom } } : contexte;
      const result = prelevementMensuel ? opts.subscriptionHandlers && provider.confirmerAbonnementPrelevementSepa ? await provider.confirmerAbonnementPrelevementSepa(avecNom, opts.subscriptionHandlers, opts.successUrl) : { error: { message: "Don mensuel indisponible", type: "validation_error" } } : provider.confirmerPrelevementSepa ? await provider.confirmerPrelevementSepa(avecNom, opts.createPaymentIntent, opts.successUrl) : { error: { message: "Moyen de paiement indisponible", type: "validation_error" } };
      if (result.error) {
        error.value = result.error;
        status.value = "error";
        opts.onError?.(result.error);
      }
      return result;
    } finally {
      isProcessing.value = false;
    }
  }
  async function confirmSubscription() {
    if (!opts.subscriptionHandlers) {
      const err = {
        message: "subscriptionHandlers non fournis \xE0 useCheckout",
        type: "validation_error"
      };
      error.value = err;
      return { error: err };
    }
    error.value = null;
    isProcessing.value = true;
    status.value = "processing";
    try {
      const result = await provider.confirmSubscription(
        buildContext(),
        opts.subscriptionHandlers,
        opts.successUrl
      );
      if (result.error) {
        error.value = result.error;
        status.value = "error";
        opts.onError?.(result.error);
      } else {
        status.value = "success";
      }
      return result;
    } finally {
      isProcessing.value = false;
    }
  }
  watch(
    [opts.amount, opts.recurring ?? ref(null), opts.feesCovered ?? ref(null)],
    async () => {
      if (!initialized) return;
      try {
        await provider.updateExpressCheckout(buildContext());
      } catch {
      }
    },
    { flush: "post" }
  );
  function destroyExpressCheckout() {
    provider.destroyExpressCheckout?.();
    conteneurExpress = null;
    expressCheckoutReady.value = false;
    expressCheckoutError.value = null;
  }
  async function rafraichirExpressCheckout() {
    const conteneur = conteneurExpress;
    if (!conteneur) return;
    destroyExpressCheckout();
    await mountExpressCheckout(conteneur);
  }
  function destroy() {
    if (unsubscribeValidity) {
      unsubscribeValidity();
      unsubscribeValidity = null;
    }
    provider.destroy();
    generationInit++;
    initEnCours = null;
    initialized = false;
    isInitialized.value = false;
    expressCheckoutReady.value = false;
    cardMounted.value = false;
    error.value = null;
    cardFormError.value = null;
    expressCheckoutError.value = null;
    status.value = "idle";
  }
  onBeforeUnmount(() => {
    destroy();
  });
  return {
    status,
    error,
    cardFormError,
    expressCheckoutError,
    cardMounted,
    availability,
    isProcessing,
    isInitialized,
    expressCheckoutReady,
    mountExpressCheckout,
    mountApplePay,
    mountGooglePay,
    mountCardForm,
    confirmCardPayment,
    confirmerMoyenLocal,
    monterPrelevementSepa,
    demonterPrelevementSepa,
    confirmerPrelevementSepa,
    confirmSubscription,
    cardFieldsValidity,
    destroy,
    destroyExpressCheckout,
    rafraichirExpressCheckout
  };
}

// src/providerRouting.ts
function extractPaypalCapabilities(raw) {
  if (!raw || typeof raw !== "object") {
    return {
      paypal_button: false,
      apple_pay: false,
      google_pay: false,
      cards: false
    };
  }
  const caps = raw;
  return {
    paypal_button: caps.PAYPAL === "ACTIVE",
    apple_pay: caps.APPLE_PAY === "ACTIVE",
    google_pay: caps.GOOGLE_PAY === "ACTIVE",
    cards: caps.PPCP_CUSTOM === "ACTIVE"
  };
}
function pickProvidersForCheckout(connections, paypalCaps, isRecurring) {
  const { stripe, paypal } = connections;
  const caps = paypalCaps ?? {
    paypal_button: false,
    apple_pay: false,
    google_pay: false,
    cards: false
  };
  if (!stripe && !paypal) {
    return {
      walletsProvider: null,
      cardProvider: null,
      showPayPalButton: false,
      recurringWalletsAvailable: false,
      reason: "aucun provider connect\xE9"
    };
  }
  if (stripe) {
    return {
      walletsProvider: "stripe",
      cardProvider: "stripe",
      showPayPalButton: paypal && caps.paypal_button,
      recurringWalletsAvailable: true,
      // Stripe supporte récurrent wallets
      reason: paypal ? "stripe-and-paypal-connected (stripe prioritaire)" : "stripe-only"
    };
  }
  if (paypal) {
    return {
      walletsProvider: !isRecurring && (caps.apple_pay || caps.google_pay) ? "paypal" : null,
      cardProvider: caps.cards ? "paypal" : null,
      showPayPalButton: caps.paypal_button,
      recurringWalletsAvailable: false,
      // PayPal ne supporte pas récurrent wallets
      reason: isRecurring ? "paypal-only (r\xE9current \u2014 wallets PayPal indisponibles, bouton PayPal/CardFields uniquement)" : "paypal-only"
    };
  }
  return {
    walletsProvider: null,
    cardProvider: null,
    showPayPalButton: false,
    recurringWalletsAvailable: false,
    reason: "unknown"
  };
}
function isPaypalCardFieldsUsable(paypal) {
  if (!paypal || paypal.charges_enabled !== true) return false;
  if (typeof paypal.card_fields_enabled === "boolean") {
    return paypal.card_fields_enabled;
  }
  return extractPaypalCapabilities(paypal.capabilities).cards;
}
function resolveCardProvider(input) {
  if (!input.stripe && !input.paypal) return null;
  if (!input.stripe) return "paypal";
  if (!input.paypal) return "stripe";
  if (input.isRecurring) return "stripe";
  if (input.preferred === "paypal" && input.paypalCardFields) return "paypal";
  return "stripe";
}

export { PaypalProvider, StripeProvider, definirRapporteurErreurPaiement, extractPaypalCapabilities, extraireDebugIdPaypal, isPaypalCardFieldsUsable, localeStripe, pickProvidersForCheckout, resolveCardProvider, textePaiement, useCheckout };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map